var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTractor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_1919)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C18 12.8969 18.8969 12 20 12H23.3219C24.1406 12 24.875 12.4969 25.1781 13.2563L26.6781 17H30V15.9437C30 15.1687 30.1812 14.4031 30.5281 13.7062L30.6062 13.55C30.8531 13.0562 31.4531 12.8562 31.9469 13.1031C32.4406 13.35 32.6406 13.95 32.3937 14.4437L32.3156 14.6C32.1062 15.0156 32 15.475 32 15.9406V17H33.75C34.4406 17 35 17.5594 35 18.25V19.6687C35 20.1844 34.7344 20.6656 34.2938 20.9406L32.9406 21.7875C32.4969 21.6031 32.0094 21.5 31.5 21.5C30.2719 21.5 29.1844 22.0906 28.5 23H26C26 23.5531 25.5531 24 25 24H24.7437C24.6906 24.15 24.6281 24.2969 24.5625 24.4406L24.7437 24.6219C25.1344 25.0125 25.1344 25.6469 24.7437 26.0375L24.0375 26.7437C23.6469 27.1344 23.0125 27.1344 22.6219 26.7437L22.4406 26.5625C22.2969 26.6313 22.15 26.6906 22 26.7437V27C22 27.5531 21.5531 28 21 28H20C19.4469 28 19 27.5531 19 27V26.7437C18.85 26.6906 18.7031 26.6281 18.5594 26.5625L18.3781 26.7437C17.9875 27.1344 17.3531 27.1344 16.9625 26.7437L16.2563 26.0344C15.8656 25.6438 15.8656 25.0094 16.2563 24.6187L16.4375 24.4375C16.3687 24.2938 16.3094 24.1469 16.2563 23.9969H16C15.4469 23.9969 15 23.55 15 22.9969V22C15 21.4469 15.4469 21 16 21H16.2563C16.3094 20.85 16.3719 20.7031 16.4375 20.5594L16.2563 20.3781C15.8656 19.9875 15.8656 19.3531 16.2563 18.9625L16.9625 18.2562C17.2437 17.975 17.6469 17.8969 17.9969 18.0188V18V17V14H18ZM23.3219 14H20V17H21H24.5219L23.3219 14ZM20.5 20C19.1187 20 18 21.1187 18 22.5C18 23.8813 19.1187 25 20.5 25C21.8813 25 23 23.8813 23 22.5C23 21.1187 21.8813 20 20.5 20ZM31.5 26C31.9156 26 32.25 25.6656 32.25 25.25C32.25 24.8344 31.9156 24.5 31.5 24.5C31.0844 24.5 30.75 24.8344 30.75 25.25C30.75 25.6656 31.0844 26 31.5 26ZM31.5 28C29.9813 28 28.75 26.7687 28.75 25.25C28.75 24.3188 29.2125 23.4969 29.9187 23C30.3656 22.6844 30.9125 22.5 31.5 22.5C31.5844 22.5 31.6656 22.5031 31.7469 22.5094C33.15 22.6344 34.25 23.8125 34.25 25.25C34.25 26.7687 33.0187 28 31.5 28Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_1919",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_1919"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractor);
export default __webpack_public_path__ + "static/media/tractor.9b6c9f12292bed3182f7f20871fe7cea.svg";
export { ForwardRef as ReactComponent };